<template>
  <div class="content">
    <div class="add-white-ip-title">
      {{ $t('registration.sp.freelancer.company.certification.white.ip.title') }}
    </div>
    <div class="add-ip-form">
      <div v-for="(value, index) in ipList" :key="index">
        <div class="text-field-section">
          <v-text-field
            :ref='index'
            @change='formChanged'
            :rules="[hostRule.hostWithRange]"
            v-model="ipList[index].address"
            dense
            outlined
            required
            :label="$t('registration.sp.freelancer.company.certification.white.ip.label')"
            :placeholder="$t('registration.sp.freelancer.company.certification.white.ip.placeholder')"
          />
          <span
            v-if='isDeletable(index)'
            class="delete-icon material-icons"
            @click="removeIp(index)"
          >
            highlight_off
          </span>
        </div>
      </div>
      <div class="add-new-ip-section">
        <v-btn color='#B331CF' class="add-btn" @click="addIp">
          <span class="plus">+</span>{{ $t('registration.sp.freelancer.company.certification.white.ip.add') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { rules } from '@/utils/validationUtils';

export default {
  name: 'SPCompanyIPWhitelistForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      index: 0,
      ipList: this.value.ipAddress ? this.value.ipAddress : [{ address: '' }],
      valid: this.value.valid,
    };
  },
  computed: {
    ...mapGetters([
      'spCompanyRegistrationCompanyIpAddressInfo',
    ]),
    hostRule() {
      return {
        ...rules,
      };
    },
  },
  methods: {
    addIp() {
      this.ipList.push({ address: '' });
    },
    isDeletable(index) {
      return index !== 0;
    },
    removeIp(index) {
      this.ipList.splice(index, 1);
    },
    async formChanged() {
      const validationArray = [];
      this.ipList.forEach((ip, index) => {
        const currentValidValue = this.$refs[index]?.[0]?.valid;
        validationArray.push(currentValidValue);
      });
      const valid = validationArray.every(value => value);
      this.$emit('onIpChange', { valid, ipAddress: this.ipList });
    },
  },
  watch: {
    ipList: {
      handler() {
        this.formChanged();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.add-white-ip-title {
  width: rem(444);
  height: rem(36);
  color: $auth-text-primary;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
}

.v-text-field__details {
  display: none;
}

#app .v-text-field .v-text-field__details {
  padding-left: 0;
  display: none;
}

.add-ip-form {
  margin-bottom: rem(32);
  display: flex;
  flex-direction: column;

  .text-field-section {
    display: flex;
    align-items: center;

    .v-text-field {
      max-width: rem(443);
      min-width: rem(443);
    }

    .delete-icon {
      color: rgb(224, 37, 94);
      cursor: pointer;
      font-size: rem(16);
      margin-left: rem(5);
      margin-top: rem(12);
    }
  }

  .add-new-ip-section {
    height: rem(16);
    color: #9BB0BE;
    font-family: $font-family-regular;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);
    text-align: center;
    margin-top: rem(10);

    .plus {
      font-size: rem(16);
      margin-top: rem(-3);
    }

    .add-btn {
      width: rem(86);
      color: #FFFFFF;
    }
  }
}
</style>
